"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConferenceInfo = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
const ConferenceInfoStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;
	width: 100%;

	input:disabled {
		background: var(--color-white, #fff);
	}

	.live-class-wrapper {
		background: var(--color-white, #ffffff);
		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		padding: 10px;
		display: flex;
		flex-direction: row;
		gap: 10px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}

	.btn-file {
		background: var(--color-silver, #f3f4f8);
		border-radius: 100px;
		padding: 4px 16px 4px 16px;
		display: flex;
		flex-direction: row;
		gap: 4px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		.overText {
			width: 100%;
		}
	}

	.conference-info {
		border-style: solid;
		border-color: var(--color-grey-c, #e6e8ed);
		border-width: 0px 0px 1px 0px;
		padding: 0px 0px 28px 0px;
		display: flex;
		flex-direction: column;
		gap: 24px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	.class-date {
		display: flex;
		width: 100%;
	}
	${props => (props.$isMobile ? mobileStyels : props.$isTablet ? tabletStyles : desktopStyles)}
`;
const mobileStyels = (0, styled_components_1.css) `
	gap: 12px;

	.class-date {
		gap: 12px;
		flex-direction: column;
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	gap: 24px;

	.class-date {
		gap: 24px;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	gap: 30px;

	.class-date {
		gap: 24px;
	}
`;
//강의모드 선택
// "lesson", "duplex", "vod"
const liveModeList = [
    { id: 'select', title: 'common.select' },
    { id: 'lesson', title: 'conference.lesson' },
    // { id: 'duplex', title: 'conference.duplex' },
    { id: 'vod', title: 'conference.vod' },
    { id: 'mock_test', title: 'conference.mock_test' },
];
exports.ConferenceInfo = react_1.default.memo(({ defaultItem, setItem, isDetail, isModify = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    // Use only the parent state for all fields
    const item = defaultItem || {
        title: '',
        conferenceMode: 'select',
        date: (0, moment_1.default)().add(5, 'minutes').startOf('minute').format('YYYY-MM-DDTHH:mm:ssZ'),
        endDate: (0, moment_1.default)().add(65, 'minutes').startOf('minute').format('YYYY-MM-DDTHH:mm:ssZ'),
        entryDate: '10',
    };
    // Dropdown value derived from item
    const dropValue = (0, react_1.useMemo)(() => liveModeList.find(i => i.id === item.conferenceMode) || liveModeList[0], [item.conferenceMode]);
    // Date and time split from item.date
    const startDate = (0, react_1.useMemo)(() => (0, moment_1.default)(item.date).format('YYYY-MM-DD'), [item.date]);
    const startTime = (0, react_1.useMemo)(() => (0, moment_1.default)(item.date).format('HH:mm'), [item.date]);
    // End date and time split from item.endDate
    const endDateStr = (0, react_1.useMemo)(() => (0, moment_1.default)(item.endDate).format('YYYY-MM-DD'), [item.endDate]);
    const endTimeStr = (0, react_1.useMemo)(() => (0, moment_1.default)(item.endDate).format('HH:mm'), [item.endDate]);
    // Handlers update only the parent state
    const handleChange = (field, value) => {
        if (!setItem)
            return;
        setItem(prev => {
            let newItem = { ...prev };
            if (field === 'date') {
                const { date, time } = value;
                newItem.date = (0, moment_1.default)(`${date}T${time}:00`).format('YYYY-MM-DDTHH:mm:ssZ');
            }
            else if (field === 'endDate') {
                const { date, time } = value;
                newItem.endDate = (0, moment_1.default)(`${date}T${time}:00`).format('YYYY-MM-DDTHH:mm:ssZ');
            }
            else if (field === 'conferenceMode') {
                newItem.conferenceMode = value;
            }
            else {
                newItem[field] = value;
            }
            return newItem;
        });
    };
    const handleDateChange = (date) => {
        handleChange('date', { date, time: startTime });
    };
    const handleTimeChange = (time) => {
        handleChange('date', { date: startDate, time });
    };
    const handleEndDateChange = (date) => {
        handleChange('endDate', { date, time: endTimeStr });
    };
    const handleEndTimeChange = (time) => {
        handleChange('endDate', { date: endDateStr, time });
    };
    const handleModeChange = (mode) => {
        handleChange('conferenceMode', mode.id);
    };
    // Render functions use only item values
    const renderTitle = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "field-global-001", style: { minWidth: `${isDesktop ? 'calc(100% - 240px)' : ''}` } },
        react_1.default.createElement("div", { className: "task-label", style: { minWidth: isDesktop && isDetail && '109px' } }, t('conference.title')),
        react_1.default.createElement("div", { className: "fext-field" },
            react_1.default.createElement(common_1.InputElement, { className: "showText", type: "text", value: item.title, isDisable: isDetail, onChange: v => handleChange('title', v) })))), [item.title, isDetail, isDesktop]);
    // 강의모드는 등록 시에만 선택하고, 수정(isModify)·상세(isDetail)에서는 변경할 수 없다.
    // (047e18fa '회의 수정 시 강의모드 변경 안 되도록' 정책 — 한 번 해제했다가 롤백)
    const renderClassMode = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "field-global-001" },
        react_1.default.createElement("div", { className: "task-label" }, t('conference.liveMode')),
        react_1.default.createElement("div", { className: "fext-field" },
            react_1.default.createElement(common_1.DropDown, { className: "dropdown-live", value: dropValue, list: liveModeList, isDisable: isDetail || isModify, option: {
                    downIcon: {
                        show: isDetail ? false : true,
                    },
                }, styles: {
                    titleWrap: { cursor: isDetail || isModify ? 'default' : 'pointer' },
                }, setDropValue: handleModeChange })))), [dropValue, isDetail, isModify]);
    const renderClassDate = (0, react_1.useMemo)(() => isMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label", style: { minWidth: isDesktop && isDetail && '109px' } }, t('conference.startDate')),
            react_1.default.createElement("div", { className: "text-line" },
                react_1.default.createElement(common_1.InputElement, { type: "date", value: startDate, isDisable: isDetail, onChange: handleDateChange }))),
        react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label", style: { minWidth: isDesktop && isDetail && '109px' } }, t('conference.startTime')),
            react_1.default.createElement("div", { className: "text-line" },
                react_1.default.createElement(common_1.InputElement, { type: "time", value: startTime, isDisable: isDetail, onChange: handleTimeChange }))))) : (react_1.default.createElement("div", { className: "field-global-001" },
        react_1.default.createElement("div", { className: "task-label", style: { minWidth: isDesktop && isDetail && '109px' } }, t('conference.startDate')),
        react_1.default.createElement("div", { className: "class-date" },
            react_1.default.createElement("div", { className: "text-line" },
                react_1.default.createElement(common_1.InputElement, { type: "date", value: startDate, isDisable: isDetail, onChange: handleDateChange })),
            react_1.default.createElement("div", { className: "text-line" },
                react_1.default.createElement(common_1.InputElement, { type: "time", value: startTime, isDisable: isDetail, onChange: handleTimeChange }))))), [isDesktop, startDate, startTime, isDetail, isMobile]);
    const renderEndDate = (0, react_1.useMemo)(() => isMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label", style: { minWidth: isDesktop && isDetail && '109px' } }, t('conference.endDate')),
            react_1.default.createElement("div", { className: "text-line" },
                react_1.default.createElement(common_1.InputElement, { type: "date", value: endDateStr, isDisable: isDetail, onChange: handleEndDateChange }))),
        react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label", style: { minWidth: isDesktop && isDetail && '109px' } }, t('conference.endTime')),
            react_1.default.createElement("div", { className: "text-line" },
                react_1.default.createElement(common_1.InputElement, { type: "time", value: endTimeStr, isDisable: isDetail, onChange: handleEndTimeChange }))))) : (react_1.default.createElement("div", { className: "field-global-001" },
        react_1.default.createElement("div", { className: "task-label", style: { minWidth: isDesktop && isDetail && '109px' } }, t('conference.endDate')),
        react_1.default.createElement("div", { className: "class-date" },
            react_1.default.createElement("div", { className: "text-line" },
                react_1.default.createElement(common_1.InputElement, { type: "date", value: endDateStr, isDisable: isDetail, onChange: handleEndDateChange })),
            react_1.default.createElement("div", { className: "text-line" },
                react_1.default.createElement(common_1.InputElement, { type: "time", value: endTimeStr, isDisable: isDetail, onChange: handleEndTimeChange }))))), [isDesktop, endDateStr, endTimeStr, isDetail, isMobile]);
    const renderEnterTime = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "field-global-001", style: { maxWidth: isDesktop ? '224px' : '' } },
        react_1.default.createElement("div", { className: "task-label" }, t('conference.enterTime')),
        react_1.default.createElement("div", { className: "text-line" },
            react_1.default.createElement(common_1.InputElement, { value: item.entryDate, className: "time", type: "text", isDisable: isDetail, onChange: v => handleChange('entryDate', v) }),
            t('conference.beforeMinute')))), [item.entryDate, isDetail]);
    if (isMobile || isTablet) {
        return (react_1.default.createElement(ConferenceInfoStyled, { "$isMobile": isMobile, "$isTablet": isTablet, className: "title-info" },
            renderTitle,
            renderClassMode,
            renderClassDate,
            renderEndDate,
            renderEnterTime));
    }
    return (react_1.default.createElement(ConferenceInfoStyled, { "$isMobile": isMobile, "$isTablet": isTablet, className: "title-info" },
        react_1.default.createElement("div", { className: "field-short", style: { maxWidth: `${isDesktop ? '80%' : ''}` } },
            renderTitle,
            renderClassMode),
        react_1.default.createElement("div", { className: "field-short", style: { maxWidth: `${isDesktop ? '80%' : ''}` } },
            renderClassDate,
            renderEndDate,
            renderEnterTime)));
});
